import { Component, Input } from '@angular/core';

/**
 * Header visual compartido entre pantallas que muestran un file/itinerary.
 *
 * Renderiza:
 *  - Título superior (input libre, sin prefijo "FILE N°" — cada padre lo construye)
 *  - Franja horizontal con destino, rango de fechas + días/noches, y pasajeros
 *  - Bloque `<usb-flight-modal>` con los datos de vuelo del traslado
 *
 * El componente es presentacional: NO toca `UserService` ni servicios globales.
 * Cada padre le pasa los valores ya calculados.
 */
@Component({
  selector: 'usb-trip-header',
  templateUrl: './trip-header.component.html',
  styleUrls: ['./trip-header.component.scss']
})
export class TripHeaderComponent {
  /** Texto del título superior. Ej: "FILE N° 1234" o "Mi Viaje a Roma". */
  @Input() title: string = '';

  /** Secuencia de ciudades. Ej: "BUE > ROM". */
  @Input() destinySecuency: string = '';

  /** Fecha completa de llegada (ya formateada por el padre si quiere). */
  @Input() arrivalDateFull: Date | string | null = null;

  /** Fecha completa de salida. */
  @Input() departureDateFull: Date | string | null = null;

  /** Horas de pickup/dropoff del traslado (texto, ej: "- 14:30 hs"). Vacío si no hay. */
  @Input() timeArrive: string = '';
  @Input() timeDropoff: string = '';

  /** Cantidad de días y noches — se muestran solo si hay hotel en el itinerario. */
  @Input() qtyDays: number = 0;
  @Input() qtyNights: number = 0;

  /** Cantidad de adultos y niños. */
  @Input() adults: number = 0;
  @Input() children: number = 0;

  /** True si el file tiene al menos un hotel — controla la visibilidad del bloque días/noches. */
  @Input() hasHotel: boolean = false;

  /** Inputs que el flight-modal necesita. */
  @Input() itinerary: any;
  @Input() payloadSearchTransportFly: any;
  @Input() formTransportsFly: any;
  @Input() clientSetting: any;
}